import { Token } from 'src/app/models/token.model';

export class LoggedIn {
  static readonly type = '[Auth] Logged In';
  constructor(public token: Token) {}
}

export class LogoutSuccess {
  static readonly type = '[Auth] Logout Success';
}
